module.exports = __webpack_public_path__ + "media/assets/images/icons/resource-generic/file-thumb-26bb7baaa5247a4a22e5b69dd2631522.png";